import type { ComponentProps } from 'react';
import Counter from 'src/components/Counter';
import useMatchCount from 'src/hooks/useMatchCount/rest';
const START = 102421;
type Props = Pick<ComponentProps<'span'>, 'className'>;

/**
 * REST 기반 매치 카운터 컴포넌트
 * 서버 부하를 줄이기 위해 실제 매치 refetch 카운트를 최소화하고 카운터 이펙트만 주기적으로 발생하도록 만들었습니다.
 *
 * 기존 매치 카운터 웹소켓은 새로운 토픽을 구성해야 해서 재활용 불가
 * 서버에서는 Vividi 관련해서 새롭게 구현하는 작업을 최소화 희망 (ws, rest API 둘 중 하나)
 * 앱 기획 요구사항에서는 매치수가 주기적으로 갱신될 필요가 없고 웹소켓을 붙여서 주기적으로 호출하는 것이 성능에 부정적인 영향을 줄 수 있기에 REST 희망
 *
 * @see {https://hpcnt.slack.com/archives/C07J2L0G4N8/p1744970328382489?thread_ts=1744683786.264409&cid=C07J2L0G4N8}
 */
export default function RecentMatchCounter({
  ...props
}: Props) {
  const matchCount = useMatchCount();
  return <Counter start={START} end={matchCount} {...props} data-sentry-element="Counter" data-sentry-component="RecentMatchCounter" data-sentry-source-file="index.tsx" />;
}